import React from "react";
import { Dimensions } from "react-native";
import RenderHtml, { defaultSystemFonts } from "react-native-render-html";
import fonts from "../../theme/fonts";
import colors from "../../theme/colors";

interface HTMLDisplayProps {
  html: string;
  fontSize?: number;
  lineHeight?: number;
  color?: string;
}

const HTMLDisplay = React.memo(({ html, fontSize = 16, lineHeight = 24, color = colors.ink.DEFAULT }: HTMLDisplayProps) => {
  return (
    <RenderHtml
      source={{ html }}
      contentWidth={Dimensions.get("window").width}
      baseStyle={{ fontFamily: fonts[400], fontSize, lineHeight, color }}
      systemFonts={[...defaultSystemFonts, ...Object.values(fonts)]}
    />
  );
});

export default HTMLDisplay;
